import "./active_applications.scss";
import ApplicationCardList from "../applications/application_card_list";
import useApplications from "@/hooks/use_applications";
import { Link, router } from "@inertiajs/react";
import EmptyState from "@components/empty_state.tsx";
import Fingerprint1 from "@images/fingerprint_1.svg";
import { useTranslation } from "react-i18next";
import MissingApplicationsModal from "@components/applications/missing_applications_modal.tsx";
import { SectionTitle } from "@/sprout/typography";
import ArrowRightIcon from "@/sprout/icons/arrow_right";
import { useDashboardPreview } from "@components/dashboard/preview_context.tsx";
import { useSafePostHog } from "@hooks/use_posthog";

export const renderHeader = (count: number = 0) => {
  const { t } = useTranslation("applications");
  return (
    <Link href="/applications">
      <div className="active-applications__header">
        <SectionTitle> {t("active_applications_count", { count })}</SectionTitle>
        <div className="active-applications__header__icon">
          <ArrowRightIcon />
        </div>
      </div>
    </Link>
  );
};

const ActiveApplications = () => {
  const { t } = useTranslation("applications");
  const { preview } = useDashboardPreview();
  const posthog = useSafePostHog();
  const { active } = useApplications({
    perPage: 10,
    preview,
  });

  const applications = active.applications;
  const totalApplications = active.count;

  const handleApplicationSelect = (id: number) => {
    const application = applications.find((app) => app.id === id);
    posthog?.capture("card_clicked", {
      card_type: "application",
      source: "dashboard",
      application_id: id,
      job_title: application?.job_title,
      company_name: application?.company_name,
    });
    router.visit(`/applications/${id}`);
  };

  return (
    <>
      {renderHeader(totalApplications)}
      <div className="active-applications__list">
        {!applications.length && (
          <EmptyState
            svg={Fingerprint1}
            svgSize={"150"}
            title={t("find_great_job")}
            fontWeight={"400"}
            message={t("missing_an_application")}
            link={<MissingApplicationsModal triggerText={t("find_out_why")} />}
          />
        )}
        <ApplicationCardList
          applications={applications}
          onApplicationSelect={handleApplicationSelect}
          showCallout={false}
        />
      </div>
    </>
  );
};

export default ActiveApplications;
